import { Logger } from '@hawtiosrc/core/logging'

export const pluginName = 'hawtio-shared'
export const log = Logger.get(pluginName)
